import React, { useState } from "react";
import "./conversation-form.css";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";

export default function ConversationForm() {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [captchaToken, setCaptchaToken] = useState(null);
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";
  const [formData, setFormData] = useState({
    form_type: "institution",
    name: "",
    email: "",
    phone: "",
    organisation: "",
    looking_for: "",
    preferred_date: "",
    location: "",
    comments: "",
    source_url: sourceUrl,
    current_url: currentUrl,
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({
        ...prev,
        phone: numericValue,
      }));

      return;
    }

    if (name === "name") {
      const textValue = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData((prev) => ({
        ...prev,
        name: textValue,
      }));

      return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleFormType = (type) => {
    setFormData((prev) => ({
      ...prev,
      form_type: type,
      organisation: "",
      looking_for: "",
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    // Full Name
    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
    }

    // Email
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Please enter a valid email";
      }
    }

    // Phone
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone is required";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Please enter a valid 10 digit phone number";
    }



    // Looking For
    if (!formData.looking_for) {
      newErrors.looking_for = "Please choose what you are interested in";
    }



    setErrors(newErrors);

    // Stop submit if validation errors exist
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${BaseUrl}/api/contact/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.error === false) {
        toast.success("Enquiry submitted successfully");

        setFormData({
          form_type: "institution",
          name: "",
          email: "",
          phone: "",
          organisation: "",
          looking_for: "",
          preferred_date: "",
          location: "",
          comments: "",
          source_url:
            typeof window !== "undefined"
              ? sessionStorage.getItem("source_url") || ""
              : "",
          current_url:
            typeof window !== "undefined"
              ? window.location.href
              : "",
        });

        setErrors({});

        setTimeout(() => {
          navigate("/thank-you");
        }, 300);
      } else {
        toast.error(
          result.message || "Something went wrong. Please try again."
        );
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while submitting the form.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="catalyze-conversation-form">
      <p className="catalyze-conversation-form-eyebrow">Partner With Catalyze</p>
      <h2>Start a Conversation</h2>
      <p className="catalyze-conversation-form-subtitle">
        Tell us a little about you and what you're looking for. We'll get
        back to you with the right next step.
      </p>
      <div className="catalyze-conversation-form-toggle" role="tablist" aria-label="Who are you?" >
        <button type="button" className={formData.form_type === "institution" ? "active" : ""}
          aria-selected={formData.form_type === "institution"} role="tab"
          onClick={() => handleFormType("institution")}  >
          We're an Institution  <small>   College / university programmes  </small>
        </button>
        <button type="button" className={formData.form_type === "individual" ? "active" : ""}
          aria-selected={formData.form_type === "individual"} role="tab"
          onClick={() => handleFormType("individual")}>
          For an Individual or Team
          <small>   Coaching, keynotes, speaking  </small>
        </button>
      </div>
      <form className="catalyze-conversation-form-grid" noValidate onSubmit={handleSubmit}>
        <div>
          <label> Full Name <span className="required">*</span>  </label>
          <input name="name" type="text" value={formData.name} onChange={handleChange} required placeholder="Enter Your name" />
          {errors.name && (
            <span className="validation-error">
              {errors.name}
            </span>
          )}
        </div>
        <div>
          <label> Phone <span className="required">*</span>  </label>
          <input name="phone" type="tel" value={formData.phone} maxLength={10} onChange={handleChange} required placeholder="Enter Phone Number" />

          {errors.phone && (
            <span className="validation-error">
              {errors.phone}
            </span>
          )}
        </div>
        <div>
          <label> Email <span className="required">*</span></label>
          <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" required />

          {errors.email && (
            <span className="validation-error">
              {errors.email}
            </span>
          )}
        </div>
        <div>
          <label> {formData.form_type === "institution" ? "Institution" : "Organisation"}
            {formData.form_type === "institution" ? (<span className="required"></span>) : (<span className="optional"> (optional)</span>)}
          </label>
          <input name="organisation" type="text" value={formData.organisation} onChange={handleChange} required={formData.form_type === "institution"}
            placeholder={formData.form_type === "institution" ? "College / university name" : "Company or team"} className={errors.organisation ? "error" : ""} />
          {errors.organisation && (
            <span className="validation-error">
              {errors.organisation}
            </span>
          )}
        </div>
        <div className="catalyze-conversation-form-section-heading"> About your engagement
        </div>
        <div className="full-width">
          <label htmlFor="looking_for">  What are you interested in?{" "} <span className="required">*</span> </label>
          <select id="looking_for" name="looking_for" value={formData.looking_for} onChange={handleChange} required   >
            <option value="" disabled>   Select an option  </option>
            {formData.form_type === "institution" && (
              <>
                <option value="Ignite — Student Readiness Programme">Ignite — Student Readiness Programme</option>
                <option value="Edge — Emerging Professionals Programme">Edge — Emerging Professionals Programme</option>
                <option value="Elevate — Leadership Programme">Elevate — Leadership Programme</option>
                <option value="Campus Workshop / Speaker Session">Campus Workshop / Speaker Session</option>
                <option value="Custom / Institution-Wide Programme">Custom / Institution-Wide Programme</option>
                <option value="Not sure yet — help me choose">Not sure yet — help me choose</option>
              </>
            )}

            {formData.form_type === "individual" && (
              <>
                <option value="Keynote / Speaking Engagement">Keynote / Speaking Engagement</option>
                <option value="Energy &amp; Leadership Coaching">Energy &amp; Leadership Coaching</option>
                <option value="Workshop / Team Session">Workshop / Team Session</option>
                <option value="Podcast / Interview">Podcast / Interview</option>
                <option value="Individual Readiness Programme">Individual Readiness Programme</option>
                <option value="Not sure yet — help me choose">Not sure yet — help me choose</option>
              </>
            )}
          </select>
          {errors.looking_for && (
            <span className="validation-error">
              {errors.looking_for}
            </span>
          )}
        </div>
        <div>
          <label> Preferred Date<span className="optional">(optional)</span></label>
          <input id="preferred_date" name="preferred_date" type="date" value={formData.preferred_date} onChange={handleChange} />
          {errors.preferred_date && (
            <span className="validation-error">
              {errors.preferred_date}
            </span>
          )} </div>
        <div>
          <label> Location<span className="optional">(optional)</span> </label>
          <input id="location" name="location" type="text" value={formData.location} onChange={handleChange} placeholder="City / campus / online" />
          {errors.location && (
            <span className="validation-error">
              {errors.location}
            </span>
          )}
        </div>
        <div className="full-width">
          <label> Additional Comments{" "}  <span className="optional">(optional)</span></label>
          <textarea id="comments" name="comments" value={formData.comments}
            onChange={handleChange} placeholder="Anything you'd like us to know — student numbers, goals, timelines…" />
          {errors.comments && (
            <span className="validation-error">
              {errors.comments}
            </span>
          )}
        </div>
        <button type="submit" className="catalyze-conversation-form-submit" disabled={loading} >
          {loading ? "Sending..." : "Send Enquiry"}
        </button>
        <p className="catalyze-conversation-form-note">
          We typically respond within 1–2 working days.
        </p>
      </form>
    </div>
  );
}
